/* eslint-disable @typescript-eslint/no-unused-vars */
import { SelectWithLabel } from '@adotel/components'
import { Divider, MenuItem, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import { useParams } from 'react-router-dom'

import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../../../helpers/date'
import { getTranslate, lang } from '../../../../localization'
import { BookingDetail } from '../../../../types/bookingDetails'
import { useStyles } from './styles/index.styles'

type Props = {
  data: BookingDetail | undefined
  originalData: BookingDetail | undefined
  adminEditMode: boolean
  bookingHistories: BookingDetail[]
  setBookingDetail: React.Dispatch<
    React.SetStateAction<BookingDetail | undefined>
  >
  setPage: React.Dispatch<React.SetStateAction<number>>
  page: number
  perPage: number
  total: number
  currentStatusId: string
  bookingId: string
}
const Status = ({
  data,
  originalData,
  adminEditMode,
  bookingHistories,
  setBookingDetail,
  page,
  setPage,
  perPage,
  total,
  currentStatusId,
  bookingId
}: Props) => {
  const classes = useStyles()
  const params = useParams<{ reserveNumber: string }>()
  const [selectedBooking, setselectedBooking] = useState<string>(bookingId)

  useEffect(() => {
    if (data) {
      if (selectedBooking === currentStatusId && originalData) {
        setBookingDetail(originalData)
      } else {
        setBookingDetail(
          selectedBooking === data.basicDetails.id
            ? data
            : bookingHistories.find(
                (item) => item.basicDetails.id === selectedBooking
              )!
        )
      }
    }
  }, [selectedBooking])

  useEffect(() => {
    setselectedBooking(bookingId)
  }, [bookingId])

  return (
    <div
      className={[
        classes.container,
        adminEditMode ? classes.adminRoot : ''
      ].join(' ')}>
      <div className={classes.top}>
        <Typography variant="h4" className={classes.title}>
          {getTranslate('Status')}
        </Typography>
      </div>
      <Divider />
      <div className={classes.bottom}>
        <InfiniteScroll
          pageStart={0}
          loadMore={() => {
            setTimeout(() => {
              setPage(page + 1)
            }, 2000)
          }}
          hasMore={perPage * page < total}
          useWindow={true}>
          <SelectWithLabel
            label={getTranslate('Change Status')}
            noHelperText
            value={selectedBooking}
            fullWidth
            onChange={(e) => {
              setselectedBooking(e.target.value)
            }}
            size="small">
            <MenuItem key="Current Status" value={currentStatusId}>
              {getTranslate('Current Status')}
            </MenuItem>
            {bookingHistories.reverse().map((historyItem, index) => {
              return (
                <MenuItem
                  key={historyItem.basicDetails.createdAt + index}
                  value={historyItem.basicDetails.id}>
                  {lang === 'en'
                    ? historyItem.basicDetails.createdAt
                    : gregorianToJalaaliWithHourMinuteAndSecond(
                        historyItem.basicDetails.createdAt
                      )}
                </MenuItem>
              )
            })}
          </SelectWithLabel>
        </InfiniteScroll>
      </div>
    </div>
  )
}

export default Status
